module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA2klEQVR4AWOgDzCeiYIMZzMYzWLQnwskgQhFClMDs+l0Yds+MYeejMJoDvOpAjYTUPRAALLZnBZTyiqDeawmyTl3ang3phdGM+jOx6HBYI62b31aQQxQBdBUIBeon8NiSnl1IKPJDCwagIoEbPuBCNkNTCYzJJ26gO7EooHReCbQMKCTUBytNy8lL07fvxYYBtht4LeZgGaDuGM3C8IGTD8AfamzAKTHcDYQsZuD/ADUhjuULCeXVwUBQ0nGqUvTpwESSgTiQcSuD+iMzKIoLvOpaGFAekwPSgAAiGaCNMDmzHcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/EU.png
// module id = 1135
// module chunks = 0